import gql from 'graphql-tag';
import {
  transientPersonWithDetailsFragment,
  condominiumCameraLiveV2Fragment,
} from '../guided_attendance/fragment';

export const localAttendanceTransientPersonSearchResponseFragment = gql`
  fragment localAttendanceTransientPersonSearchResponseParts on LocalAttendanceTransientPersonSearchResponse {
    pagination {
      page
      pageSize
      hasNextPage
    }
    collection {
      ...transientPersonWithDetailsParts
    }
  }
  ${transientPersonWithDetailsFragment}
`;

export const localAttendanceCameraLiveFragment = gql`
  fragment localAttendanceCameraLiveParts on LocalAttendanceCameraLiveResponse {
    webcamCaptureEnabled
    cameras {
      ...condominiumCameraLiveV2Parts
    }
  }
  ${condominiumCameraLiveV2Fragment}
`;

export const transientPersonDocumentPhotoFragment = gql`
  fragment transientPersonDocumentPhotoParts on TransientPersonDocumentPhoto {
    id
    documentId
    documentPhotoUrl
    transientPersonId
  }
`;

export const transientPersonLastAccessFragment = gql`
  fragment transientPersonLastAccessParts on TransientPersonLastAccess {
    unity {
      id
      name
      treeNodeId
    }
    unityGroup {
      id
      name
      treeNodeId
    }
    authorizedOn
  }
`;

export const transientPersonLastAccessesResponseFragment = gql`
  fragment transientPersonLastAccessesResponseParts on TransientPersonLastAccessesResponse {
    collection {
      ...transientPersonLastAccessParts
    }
    pagination {
      page
      pageSize
      hasNextPage
    }
  }
  ${transientPersonLastAccessFragment}
`;

const localAttendanceCondominiumCamerasFragment = gql`
  fragment localAttendanceCondominiumCamerasParts on CameraData {
    thumbnail
    placeId
    deviceTypeId
    parentDeviceId
    serialNumber
    ip
    name
    serializedParams
    isOnline
    id
    creationDate
    canTakeFacePhoto
  }
`;

export const getCondominiumCameras = gql`
  query localAttendanceCondominiumCameras($condominiumPersonContextId: ID!) {
    localAttendanceCondominiumCameras(
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      ...localAttendanceCondominiumCamerasParts
    }
  }
  ${localAttendanceCondominiumCamerasFragment}
`;
